import { styled } from '@linaria/react';
import { space } from '../../theme/tokens';
import type { RadioButtonVariant } from '../RadioButton/RadioButton.types';

const gapFor = (direction: 'row' | 'column', variant: RadioButtonVariant) => {
  if (variant === 'card') return space['space-400'];
  return direction === 'column' ? space['space-200'] : space['space-400'];
};

export const Group = styled.div<{ $direction: 'row' | 'column'; $variant: RadioButtonVariant }>`
  display: flex;
  flex-direction: ${(p) => p.$direction};
  gap: ${(p) => gapFor(p.$direction, p.$variant)};
`;
